/**
 * Format a lesson/course duration given in whole minutes, e.g. `12 min`.
 * Returns `-` when no duration is set. (Distinct from `formatDuration`, which
 * formats a seconds-based media duration.)
 */
export function formatLessonDuration(minutes?: number): string {
  return typeof minutes === 'number' ? `${minutes} min` : '-';
}
